package ir.site.zero1plus.helper

import com.varabyte.kobweb.silk.style.CssStyleScope
import org.jetbrains.compose.web.css.CSSColorValue

fun CssStyleScope.colorModeDetect(
    darkMode:  CSSColorValue,
    lightMode: CSSColorValue
) = run {
    if (colorMode.isDark) {
        darkMode
    } else {
        lightMode
    }
}